export const ITRService = {
    postITRDocuments
}

const { REACT_APP_CREDIT_SERVICE_API_BASE_URL } = process.env;

function postITRDocuments(ITR) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ITR)
    };

    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/itr/submit_itr_details`, requestOptions).then(handleResponse);
}

function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            // if (response.status === 401) {
            //     logout();
            // }
            const error = (data && data) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}